'use client';

import { reactive } from '@legendapp/state/react';
import { motion } from 'framer-motion';

export const ReactiveMotionDiv = reactive(motion.div);
